import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';


const TCverification = () => {
  return (
    <div>
      <Container>
        <h3 className='text-center mt-5 mb-5'>Download TC</h3>
        <Row className='d-flex justify-content-center' style={{ marginTop: '8rem', marginBottom: '20rem' }}>
          <Col md={4} className='shadow p-3 mb-5 bg-body-tertiary rounded'>
            <Form.Label className='mb-5' htmlFor="inputPassword5">Transfer Certificate Number</Form.Label>
            <Form.Control
              type="text"
              id="inputPassword5"
              aria-describedby="passwordHelpBlock"
            />
             <Button className='mt-5' variant="primary">Download</Button>
          </Col>
        </Row>
      </Container>

    </div>
  )
}

export default TCverification